import { render, staticRenderFns } from "./ComplianceBadge.vue?vue&type=template&id=62eb711e&"
import script from "./ComplianceBadge.vue?vue&type=script&lang=js&"
export * from "./ComplianceBadge.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports